const linkWithFilter = ({ parentRegion, childRegion, page }) => {
	const pieces = ['support-organisations', parentRegion || 'all', childRegion || 'all'];
	while (pieces[pieces.length - 1] === 'all') pieces.pop();

	if ((page || 1) !== 1) pieces.push(page);
	return `/${pieces.join('/')}`;
};

module.exports = {
	// Takes the type field like 'inside-out-publications' and swaps dashes for spaces so it can
	// be displayed nicely in the tile.
	typeToDescription: type => {
		// fact-sheet becomes Fact Sheet
		return type
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.substring(1))
			.join(' ');
	},

	// When provided with a kebab-case string array of audiences, generates the full object array the component needs
	fullAudiences: audiences =>
		audiences
			.map(audience => {
				switch (audience) {
					case 'for-myself':
						return { id: 'for-myself', title: 'For Myself' };
					case 'family-and-carers':
						return { id: 'family-and-carers', title: 'Family & Carers' };
					case 'for-healthcare-professionals':
						return { id: 'for-healthcare-professionals', title: 'For Healthcare Professionals' };
				}
			})
			.filter(audience => audience),

	audiences: ['for-myself', 'family-and-carers', 'for-healthcare-professionals'],

	linkWithFilter,

	prepareRegions: ({ parentRegions, childRegions }) => {
		const regions = {};
		const validParents = new Set(parentRegions.edges.map(({ node }) => node.title));

		for (const parent of validParents) {
			regions[parent] = [];
		}

		for (const { node } of childRegions.edges) {
			if (validParents.has(node.parent_region)) {
				regions[node.parent_region].push(node.title);
			} else {
				console.warn(
					`- Child Region ${node.title} has an invalid parent and was not connected. Parent: ${
						node.parent_region
					}`
				);
			}
		}

		return regions;
	},
};



// WEBPACK FOOTER //
// ./src/managers/supportOrganisationsManager.js